module.exports = __webpack_public_path__ + "static/media/insitu_con_pou.47721cb0.png";